<template>
  <div>
    <select-field v-model="type" label="上报类型" :list="uploadTypeList" :disabled="!editable"></select-field>
    <vue-form :defaults="formDefaults" @submit="submit" :disabled="!editable"></vue-form>
  </div>
</template>

<script>
  import SelectField from '@/components/utils/select-field'
  import VueForm from '@/components/utils/vue-form'

  export default {
    data () {
      return {
        type: '',
        args: {}
      }
    },
    props: {
      defaults: { /* { uploadOptions, type, args } */
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'plc-device-data',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    components: {
      VueForm,
      SelectField
    },
    computed: {
      formDefaults () {
        return Object.keys(this.defaults.uploadOptions).includes(this.type) ? {
          parameters: this.defaults.uploadOptions[this.type].parameters,
          args: this.args || {}
        } : {
          parameters: []
        }
      },
      uploadTypeList () {
        return Object.entries(this.defaults.uploadOptions).map(([key, value]) => {
          return {
            key: value.name,
            value: key
          }
        })
      }
    },
    methods: {
      submit (data) {
        data = Object.entries(data).reduce((acc, [ key, value ]) => {
          if (value !== undefined && value !== '') {
            acc[key] = value
          }

          return acc
        }, {})

        this.$emitter.emit(this.event, {
          type: this.type,
          args: data
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      },
      refresh () {
        this.type = this.defaults.type
        this.args = this.defaults.args
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      defaults () {
        this.refresh()
      },
      type () {
        if (this.defaults.type === this.type) {
          this.args = this.defaults.args
        } else {
          this.args = {}
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/upload.vue